<template>
  <div class="ma-10">
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Privacy Policy</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Create Privacy Policy"
          style="background-color: #3b54d9; color: #ffffff; width: 240px"
          @click="() => $router.push('/privacy-policy/new')"
        />
      </div>
    </div>
    <v-row>
      <!-- Search  -->
      <v-col>
        <div class="action-head">
          <div class="f-search">
            <!-- Input -->
            <div>
              <v-text-field
                v-model="filter.name"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="applyFilters"
              ></v-text-field>
            </div>
            <!-- Icon -->
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        style="display: flex; justify-content: flex-end; gap: 10px"
      ></v-col>
    </v-row>
    <NewTable
      :headers="headers"
      :rows="privacy_policy"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getPrivacyPolicy"
    />
    
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import getAuthentification from "@/utils/badrequest.js";
import moment from "moment";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";

export default {
  components: {
    Button,
    Loading,
    Popup,
    NewTable
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      search: "",
      id: 0,
      totalData: 0,
      perPage: 10,
      isFilterActive: false,
      message: "",
      isPopup: false,
      filter: {
        name: "",
      },
      headers: [
    
        {
          text: "Judul",
          field: "title",
          width: 200 
        },
        {
          text: "Slug Name",
          field: "slug_name",
          width: 200 
        },
        {
          text: "Tanggal Dibuat",
          field: "created_at",
          width: 200 
        },
      ],
      privacy_policy: [],
    };
  },
  methods: {
    applyFilters() {
      this.getPrivacyPolicy();
      this.showFilterModal = false;
    },
    async getPrivacyPolicy(page) {

      if (!page) page = this.currentPage
      else this.currentPage = page

      await this.$crm_http
        .get(
          `/v1/privacy-policy?&title=${this.filter.name || ""}&page=${page}&per_page=${this.perPage}`
        )
        .then((response) => {
          this.privacy_policy = [];
          this.privacy_policy= response.data.data.privacy_policys.map((element) => ({
              id: element.id,
              title: element.title,
              slug_name: element.slug_name,
              created_at: this.format_date(element.created_at),
            }));
          const t = parseInt(response.data.data.total);
          this.total = Math.ceil(t / 10);
          this.totalData = response.data.data.total;
        })
        .catch((err) => {
          this.message = err.response.data.data
          this.isPopup = true
        });
    },
    watchItem(id) {
      this.$router.push(`/privacy-policy/watch/` + id);
    },
    editItem(id) {
      this.$router.push(`/privacy-policy/edit/` + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/privacy-policy/" + id);
        this.getPrivacyPolicy();
        this.isLoading = false;
      } catch (err) {
        this.message = err.response.data.data
        this.isPopup = true
        this.isLoading = false;
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    onFilter() {
      this.currentPage = 1;
      this.isFilterActive = true;
      this.getPrivacyPolicy();
    },
    clearFilter() {
      this.isFilterActive = false;
      this.filter = {
        title: "",
      };
      this.getPrivacyPolicy();
    },
    handleClearButtonClick() {
      this.filter = {
        title: "",
      };
      this.updateIsFilterActive();
    },
    updateIsFilterActive() {
      this.isFilterActive = !!this.filter.title;
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getPrivacyPolicy();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  font-weight: bold;
  font-size: 19px;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
</style>
